import { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'

import {
  accountLoad,
  audienceLoad,
  campaignLoad,
  templateLoad,
  statsLoad
} from '../../../../redux/actions'

const LoadComponents = ({
  auth,
  account,
  audience,
  campaign,
  template,
  dashboard,
  stats
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!stats.init && auth.me) {
      dispatch(statsLoad())
    }
  }, [auth.me, dispatch, stats.init])

  useEffect(() => {
    if (!account.init && auth.me) {
      dispatch(accountLoad())
    }
  }, [auth.me, dispatch, account.init])

  useEffect(() => {
    if (!audience.init && auth.me) {
      dispatch(audienceLoad())
    }
  }, [auth.me, dispatch, audience.init])

  useEffect(() => {
    if (!campaign.init && auth.me) {
      dispatch(campaignLoad())
    }
  }, [auth.me, dispatch, campaign.init])

  useEffect(() => {
    if (!template.init && auth.me) {
      dispatch(templateLoad())
    }
  }, [auth.me, dispatch, template.init])

  return null
}

export default connect((state) => {
  return state
})(LoadComponents)
